import { useTranslation } from 'react-i18next'
import { formatPercent } from '@/utils/format'

export const RateCell = ({ value }: { value: number | undefined }) => {
  const { i18n } = useTranslation()
  return <>{formatPercent(value ?? 0, i18n.language, 2)}</>
}

export const TOOLTIP_TAGS = { b: <b />, br: <br /> }
